<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Contribuciones totales HOE</h1>
</div>

<!--&================= CONTAINER BAR NAVIGATION =================&-->

<div class="Options-Menu">
  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-filter"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Filtro</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input Inputng-Select">
          <i class="fa-regular fa-circle-question"></i>
          <ng-select
            [searchable]="false"
            bindLabel="Name"
            [clearable]="false"
            (change)="Reload_Page()"
            [items]="Option_Type_Filter"
            [(ngModel)]="Select_Option_Type_Filter"
          >
          </ng-select>
          <i class="fa-solid fa-angle-down"></i>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="far fa-calendar-alt"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Periodo</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input calendar">
          <div class="calendar-container">
            <p-datepicker
              [(ngModel)]="StartDate"
              (ngModelChange)="Reload_Page()"
            ></p-datepicker>
          </div>
          <div class="separator">
            <i class="fa-solid fa-arrows-left-right"></i>
          </div>
          <div class="calendar-container">
            <p-datepicker
              [(ngModel)]="EndDate"
              (ngModelChange)="Reload_Page()"
            ></p-datepicker>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER INFORMATION =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">
          <button (click)="Reload_Page()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER INFORMATION =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="information">
        <div class="option">
          <div class="Option-Title"><h2>Contribuciones totales</h2></div>
          <div class="Input-Option">{{ DataContributions.total }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="chart">
  <div class="chart__section chart__section--cards">
    <div class="Options-Menu">
      <div class="Card-Option container-global-components">
        <div class="Icon-Left">
          <div class="Local-Icon-Card button-square">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>

        <div class="Container-Card">
          <div class="information">
            <div class="option">
              <div class="Option-Title">
                <h2>HOE aprobadas actuales en S.</h2>
              </div>
              <div class="Input-Option">{{ DataContributions.approved }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="Card-Option container-global-components">
        <div class="Icon-Left">
          <div class="Local-Icon-Card button-square">
            <i class="fas fa-times-circle"></i>
          </div>
        </div>

        <div class="Container-Card">
          <div class="information">
            <div class="option">
              <div class="Option-Title">
                <h2>HOE rechazadas actuales en S.</h2>
              </div>
              <div class="Input-Option">{{ DataContributions.rejected }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="Card-Option container-global-components">
        <div class="Icon-Left">
          <div class="Local-Icon-Card button-square">
            <i class="fas fa-clock"></i>
          </div>
        </div>

        <div class="Container-Card">
          <div class="information">
            <div class="option">
              <div class="Option-Title">
                <h2>HOE pendientes actuales en S.</h2>
              </div>
              <div class="Input-Option">{{ DataContributions.pending }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="Card-Option container-global-components">
        <div class="Icon-Left">
          <div class="Local-Icon-Card button-square">
            <i class="fas fa-hashtag"></i>
          </div>
        </div>

        <div class="Container-Card">
          <div class="information">
            <div class="option">
              <div class="Option-Title">
                <h2>Total de HOE actuales en S.</h2>
              </div>
              <div class="Input-Option">
                {{ DataContributions.totalCurrent }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Card-Option container-global-components">
        <div class="Icon-Left">
          <div class="Local-Icon-Card button-square">
            <i class="fas fa-equals"></i>
          </div>
        </div>

        <div class="Container-Card">
          <div class="information">
            <div class="option">
              <div class="Option-Title">
                <h2>
                  Promedio de carga por {{ Select_Option_Type_Filter.Name }}
                </h2>
              </div>
              <div class="Input-Option">{{ DataContributions.media }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="Card-Option container-global-components">
        <div class="Icon-Left">
          <div class="Local-Icon-Card button-square">
            <i class="fab fa-think-peaks"></i>
          </div>
        </div>

        <div class="Container-Card">
          <div class="information">
            <div class="option">
              <div class="Option-Title"><h2>Pico de carga</h2></div>
              <div class="Input-Option">{{ DataContributions.peak }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="chart__section chart__section--area">
    <div class="chart__area container-global-components">
      <app-large-chart-arearc [DataChartArea]="DataChartAreaCCP" />
    </div>
  </div>
  <div class="chart__section chart__section--pie">
    <div class="chart__pie container-global-components">
      <app-simple-chart-pierc [DataChartPie]="DataChartPieCCP" />
    </div>
    <div class="chart__pie container-global-components">
      <app-sim-chart-pie-angle [DataChartPieAngle]="DataChartPieAngleCCP" />
    </div>
  </div>
</div>

<div *ngIf="!LoadPage" class="Container-Loader-Global active" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
